import http from '@/plugins/request'
//标签替换
export const replaceCode = (data) => {
    return http.request({
        url: 'fch/pda/replace',
        method: 'post',
        data
    })
}
